import React, { useEffect, useState } from 'react';
import { Card } from '@material-ui/core';
import Button from '../../common/Button';
import Header from '../../common/Header';
import CommonForm from '../../common/CommonForm2';
import Constants from '../../data/Constants';
import { v4 as uuidv4 } from 'uuid';

export default function AutomationLogicalConditionsForm({
  language,
  actionsAutomation,
  handleValue,
  setValue,
  options,
  execute,
  spinner,
  toggleAlert,
}) {   
  let op = {
    mail: {
      label: language.EMAIL,
    },
    subject: {
      label: language.SUBJECT,
    },
    solicitant: {
      label: language.SOLICITANT,
      options: options.solicitant(),
    },
    category: {
      label: language.CATEGORY,
      options: options.categories(),
    },
    subcategory: {
      label: language.CATALOG,
      options: options.subCategory(),
    },
    company: {
      label: language.COMPANY,
    },
  };

  function setState(newValue){   
    handleValue(newValue, 'actions_automation');    
    setValue('actions_automation', newValue);
  }

   const onChangeField = (field, value, itemIndex, idGroup) => {        
      const updatedActionsAutomation = actionsAutomation.map((group) => {      
         const updatedGroup = group.map((item) => {
            if (item.id_role === itemIndex) {
               return {...item, [field.name]: value};
            }
            return item; 
         });      
         return updatedGroup; 
      });   
      setState(updatedActionsAutomation);
   };

  function onRemoveAction(fk_id_automation, id_action_automation, idRole) {
    spinner = true;
    let delItem;
    if (fk_id_automation && id_action_automation) {
      delItem = actionsAutomation.map(subarray => subarray.filter(item => item.id_role !== idRole)).filter(subarray => subarray.length > 0);   
      execute('delete',`${Constants.APIEndpoints.AUTOMATION}/${fk_id_automation}/action/${id_action_automation}`,'')
        .then(() => {
          spinner = false;                   
          setState(delItem);
          toggleAlert(true, language.ALERT_DELETE_SUCCESS, 'success');
        })
        .catch((error) => {
          let messageError = language.ERROR_REQUEST;          
          if( error.data?.id_error === "92d94145-70f0-4608-9731-e22551fef3e3" ) {
            messageError = language.THERE_ARE_NO_RECORDS_TO_DELETE;
          }else if(error.data?.id_error === "e8593f9c-c16f-4b78-8c81-bd29e777d8c1"){
            messageError = language.THERE_IS_ONLY_ONE_RECORD_MODIFY_THE_CURRENT_ONE;
          }
          spinner = false;
          toggleAlert(true, messageError, 'error');
        });
    } else {
      delItem = actionsAutomation.map(subarray => subarray.filter(item => item.id_role !== idRole)).filter(subarray => subarray.length > 0);      
      setTimeout(() => {
        spinner = false;      
         setState(delItem)
        toggleAlert(true, language.ALERT_DELETE_SUCCESS, 'success');
      }, 100);      
    }
  }

  const onAddCondition = (idGroup) => {   
   const newCondition = {
     id_role: uuidv4(),
     id_group: idGroup ? idGroup : uuidv4(),
     id_action_automation: null,
     fk_id_automation: null,
     type: undefined,
     action: undefined,
     description: undefined 
   };
 
   const updatedActionsAutomation = actionsAutomation.map((group) => {
      if (group.some((data) => data.id_group === idGroup)) {        
        return [...group, newCondition];
      }
      return group; 
    });
 
   setState(updatedActionsAutomation); 
 };

  return (
    <div style={{ zoom: 0.8 }}>
      <Header
        className="justify-content-start"
        style={{
          height: 24,
          borderRadius: '7px 7px 0 0',
        }}
      >
        <Button
          icon="fas fa-plus"
          variant="circle"
          color="warning"
          label={language.ADD}
          className="mr-3"
          onClick={() => {
            const newGroup = [
               {
                  id_role: uuidv4(),
                  id_group: uuidv4(),
                  id_action_automation: undefined,
                  fk_id_automation: undefined,
                  type: undefined,
                  action: undefined,
                  description: undefined
               }
            ]
            if (!actionsAutomation) {
               actionsAutomation = []               
            }
            actionsAutomation.push(newGroup)            
            setState(actionsAutomation)
          }}
        />
      </Header>
      <Card style={{ overflow: 'visible' }} className="content mb-3">
         {actionsAutomation && Array.isArray(actionsAutomation) && actionsAutomation.map((groupCondition, groupIndex) => (
            <>
               <div key={groupIndex} style={{ 
                     border: '1px solid #2ba5b1c4', 
                     background: 'rgb(203 198 198 / 13%)', 
                     padding: 15, 
                     borderRadius: 10, 
                     marginBottom: 10
                  }}
               >
                  {groupCondition.map((e, index) => (
                     <div className="w-100 mb-2" style={{ marginTop: 15 }} key={index}>
                        <CommonForm
                           individual
                           values={{                        
                              type: e.type,
                              action: e.action,
                              description: parseInt(e.description) || e.description,
                           }}
                           fields={[
                           {
                              col: 3.85,
                              type: 'select',
                              name: 'action',
                              label: language.CONDITION,
                              options: options.action(),
                              required: true
                           },
                           {
                              col: 3.85,
                              type: 'select',
                              name: 'type',
                              label: language.OPERATOR,
                              required: true,
                              options:
                              e.action === 'description' ? options.type().filter((op) => op.value !== 'in' && op.value !== 'no_in'): options.type(),
                           },
                           {
                              col: 3.85,
                              type: 'text',
                              name: 'description',
                              required: true,
                              label: language.DESCRIPTION,
                              visible: !!(['mail', 'subject', 'description'].includes(e.action) &&!!e.action),
                           },
                           e.action == 'solicitant'
                              ? {
                                 col: 3.85,
                                 type: 'autocomplete',
                                 name: 'description',
                                 textlabel: language.SOLICITANT,
                                 label: language.SOLICITANT,
                                 className: 'tech-group-ticket',
                                 required: true,
                                 method: 'POST',
                                 route: `${Constants.APIEndpoints.USER}/filter`,
                                 routeGetCount: `${Constants.APIEndpoints.USER}/active/count/all`,
                                 fieldquery: 'search',
                                 textinit: e.name,
                                 fieldvaluedb: 'id_user',
                                 fieldlabeldb: 'name',
                                 idinit: parseInt(e.description) || e.description,
                                 routeAll: `${Constants.APIEndpoints.USER}/filter/all?`,
                                 loadOnFocus: true,
                                 detail: true,
                                 methodGetAll: 'POST',
                              }
                              : e.action === 'company'
                              ? {
                                 col: 3.85,
                                 type: 'autocomplete',
                                 name: 'description',
                                 textlabel: language.COMPANY,
                                 label: language.COMPANY,
                                 className: 'tech-group-ticket',
                                 required: true,
                                 method: 'POST',
                                 route: `${Constants.APIEndpoints.COMPANY}/filter`,
                                 routeGetCount: `${Constants.APIEndpoints.COMPANY}/count`,
                                 fieldquery: 'search',
                                 textinit: e.name_company,
                                 fieldvaluedb: 'id_company',
                                 fieldlabeldb: 'name',
                                 idinit: parseInt(e.description) || e.description,
                                 routeAll: `${Constants.APIEndpoints.COMPANY}/all?`,
                                 detail: true,
                                 loadOnFocus: true,
                                 methodGetAll: 'POST',
                              }
                              : {
                                 col: 3.85,
                                 name: 'description',
                                 type: 'select',
                                 visible: !!(!['mail', 'subject', 'description'].includes(e.action) && !!e.action),
                                 ...op[e.action],
                              },
                           {
                              col: 0.45,
                              type: 'element',
                              content: () => (
                              <Button
                                 variant="circle"
                                 icon="fas fa-trash-alt"
                                 color="danger"
                                 label={language.DELETE}
                                 className="mt-4 -ml-3"
                                 size={0.7}
                                 onClick={() =>
                                    onRemoveAction(e.fk_id_automation, e.id_action_automation, e.id_role)
                                 }
                              />
                              ),
                           },
                           ]}
                           onChangeField={(f, v) => onChangeField(f, v, e.id_role, e.id_group)}
                        />
                     </div>
                  ))}
                  <Button
                     label={language.ADD_RULE}
                     variant="normal"
                     style={{ marginTop: '15px' }}
                     color="success"
                     onClick={() => onAddCondition(groupCondition[0]?.id_group)}
                  />               
               </div>  
               <div style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: 16, fontSize: 20, }}>
                  {  groupIndex +1 < actionsAutomation.length ? language.OR.toUpperCase() : ''}
               </div>        
            </>
         ))}
      </Card>
    </div>
  );
}
